export default {
    topics: [
        {
            title: ' save ',
            href: 'm-Entity-save.html',
            attributes: { 'data-id': 'm-Entity-save' },
            menu: { hasChildren: false },
            tocID: 'm-Entity-save-d66e6749',
            topics: [],
        },
    ],
};

